import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import { BACKEND_URL } from "../config";

class pastProjects extends React.Component {
  constructor(props) {
    super(props);

    let loggedIn = false;
    const token2 = localStorage.getItem("token2");

    if (token2 === "3424732dhakjfkjdafshi4128hdjsh8923") {
      loggedIn = true;
    }
    if (loggedIn === false) {
      this.props.history.push("/adminLogin");
    }

    this.state = {
      projects: [],
      loggedIn,
      loggedOut: false,

      // For Add Modal
      showAddModal: false,
      newName: "",
      newDescription: "",
      newEndUsers: "",
      newYearOfCompletion: "",
      newTeamLeads: "",
      newMembersInvolved: "",
    };
  }

  async componentDidMount() {
    try {
      const res = await axios.get(BACKEND_URL + "/pastprojects");
      const sortedProjects = res.data.sort((a, b) => a.yearOfCompletion - b.yearOfCompletion);
        this.setState({ projects: sortedProjects });
    } catch (err) {
      console.log(err);
    }
  }

  logout = () => {
    localStorage.removeItem("token2");
    this.setState({
      loggedOut: true,
    });
  };

  showIndex = (index) => {
    return index + 1;
  };

  openAddModal = () => this.setState({ showAddModal: true });
  closeAddModal = () => this.setState({ showAddModal: false });

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleAddProject = async () => {
    const {
      newName,
      newDescription,
      newEndUsers,
      newYearOfCompletion,
      newTeamLeads,
      newMembersInvolved,
    } = this.state;

    if (!newName || !newDescription || !newEndUsers || !newYearOfCompletion) {
      Swal.fire("Error", "Please fill all required fields", "error");
      return;
    }

    try {
      const payload = {
        name: newName,
        description: newDescription,
        endUsers: newEndUsers,
        yearOfCompletion: Number(newYearOfCompletion),
        teamLeads: newTeamLeads
          ? newTeamLeads.split(",").map((s) => s.trim())
          : [],
        membersInvolved: newMembersInvolved
          ? newMembersInvolved.split(",").map((s) => s.trim())
          : [],
      };

      await axios.post(`${BACKEND_URL}/pastprojects/add`, payload);

      Swal.fire("Success", "Project added!", "success");

      this.closeAddModal();

      // Refresh projects list
      const res = await axios.get(BACKEND_URL + "/pastprojects");
    const sortedProjects = res.data.sort((a, b) => a.yearOfCompletion - b.yearOfCompletion);
    this.setState({ projects: sortedProjects });

      // Clear form
      this.setState({
        newName: "",
        newDescription: "",
        newEndUsers: "",
        newYearOfCompletion: "",
        newTeamLeads: "",
        newMembersInvolved: "",
      });
    } catch (err) {
      Swal.fire("Error", "Failed to add project", "error");
    }
  };

  async deleteProject(index) {
    if (index < this.state.projects.length && index >= 0) {
      const projectId = this.state.projects[index]._id;

      try {
        const result = await Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Cancel",
        });

        if (result.isConfirmed) {
          // Optimistically remove from UI
          const updatedProjects = this.state.projects.filter(
            (_, i) => i !== index
          );
          this.setState({ projects: updatedProjects });

          // Delete from server
          await axios.delete(`${BACKEND_URL}/pastprojects/${projectId}`);

          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "The project has been deleted.",
            confirmButtonText: "OK",
          });
        }
      } catch (err) {
        console.error("Error deleting project:", err);

        // Rollback UI update on error
        this.setState({ projects: this.state.projects });

        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to delete the project. Please try again.",
          confirmButtonText: "OK",
        });
      }
    }
  }

  showData = (projects) => {
    return projects.map((project, index) => (
      <tr key={project._id}>
        <td>{this.showIndex(index)}</td>
        <td>{project.name}</td>
        <td>{project.description}</td>
        <td>{project.endUsers}</td>
        <td>{project.yearOfCompletion}</td>
        <td>{project.teamLeads.join(", ")}</td>
        <td>{project.membersInvolved.join(", ")}</td>
        <td className="text-center" onClick={() => this.deleteProject(index)}><i className="fa fa-trash text-danger h3"></i></td>
      </tr>
    ));
  };

  render() {
    if (this.state.loggedIn === false || this.state.loggedOut === true) {
      return <Redirect to="/adminLogin" />;
    }

    return (
      <div className="App">
        <Header title="SDS Portal - Admin Panel" />
        <Link className="logout text-light" onClick={this.logout}>
          Logout
        </Link>
        <ul className="d-flex flex-row list-group mt-3 ml-3 mb-3">
          <li className="list-group-item ">
            <Link to="/AdminPanel">All Projects</Link>
          </li>
          <li className="list-group-item">
            <Link to="/nonApproved">Non Approved Projects</Link>
          </li>
          <li className="list-group-item list-group-item-primary">
            <Link to="/pastProjects">Past Projects</Link>
          </li>
        </ul>

        <div
        className="d-flex justify-content-between align-items-center mb-3"
        style={{ marginTop: "1rem", paddingLeft: "4.2rem", paddingRight: "4.2rem", }}
        >
            <h2 className="">Past Projects</h2>
            <button className="btn btn-primary" onClick={this.openAddModal}>
                + Add Project
            </button>
        </div>

        <div
        className="d-flex justify-content-between align-items-center mb-3"
        style={{ marginBottom: "1rem", paddingLeft: "4.2rem", paddingRight: "4.2rem", }}
        >
            <p>A collection of projects completed before the SDS portal was introduced:</p>
        </div>

        <div
          className="table-responsive tableFixHead"
          style={{
            height: "28rem",
            marginBottom: "1.2rem",
            width: "auto",
            marginLeft: "4.2rem",
            marginRight: "4.2rem",
          }}
        >
          <table className="table table-striped table-bordered">
            <thead className="thead-dark">
              <tr>
                <th>Sr No.</th>
                <th>Project Name</th>
                <th>Description</th>
                <th>End Users</th>
                <th>Year Of Completion</th>
                <th>Team Leads</th>
                <th>Members Involved</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>{this.showData(this.state.projects)}</tbody>
          </table>
        </div>

        {/* Add Project Modal */}
        {this.state.showAddModal && (
          <div
            className="modal d-block"
            tabIndex="-1"
            role="dialog"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Add Past Project</h5>
                  <button
                    type="button"
                    className="close"
                    onClick={this.closeAddModal}
                  >
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="form-group">
                      <label>Project Name *</label>
                      <input
                        type="text"
                        name="newName"
                        className="form-control"
                        value={this.state.newName}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Description *</label>
                      <textarea
                        name="newDescription"
                        className="form-control"
                        value={this.state.newDescription}
                        onChange={this.handleChange}
                        required
                      ></textarea>
                    </div>
                    <div className="form-group">
                      <label>End Users *</label>
                      <input
                        type="text"
                        name="newEndUsers"
                        className="form-control"
                        value={this.state.newEndUsers}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Year of Completion *</label>
                      <input
                        type="number"
                        name="newYearOfCompletion"
                        className="form-control"
                        value={this.state.newYearOfCompletion}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Team Leads (comma separated)</label>
                      <input
                        type="text"
                        name="newTeamLeads"
                        className="form-control"
                        value={this.state.newTeamLeads}
                        onChange={this.handleChange}
                      />
                    </div>
                    <div className="form-group">
                      <label>Members Involved (comma separated)</label>
                      <input
                        type="text"
                        name="newMembersInvolved"
                        className="form-control"
                        value={this.state.newMembersInvolved}
                        onChange={this.handleChange}
                      />
                    </div>
                  </form>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={this.closeAddModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.handleAddProject}
                  >
                    Add Project
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <Footer />
      </div>
    );
  }
}

export default pastProjects;
